import React, { memo } from 'react';
import useAuth from 'src/hooks/useAuth';
import SelectLanguage from './SelectLanguage';

interface INavBar {
  title: string;
}

const Navbar: React.FC<INavBar> = ({ title }) => {
  const { isShuster } = useAuth();

  return (
    <nav
      className={`flex items-center min-h-9 px-4 py-1 shadow-md sm:h-9 sm:py-0 ${
        isShuster ? 'bg-[#676767]' : 'bg-[#94c947]'
      }`}
    >
      <div className="flex w-full flex-col gap-x-2 sm:flex-row sm:items-center sm:justify-between sm:gap-x-2">
        <div className="flex min-w-0 w-full items-center sm:flex-1">
          <p
            className="m-0 w-full break-words text-xl font-bold text-white sm:truncate sm:whitespace-nowrap"
            title={title}
          >
            {title}
          </p>
        </div>
        <div className="flex shrink-0 items-center sm:w-auto">
          <SelectLanguage />
        </div>
      </div>
    </nav>
  );
};

export default memo(Navbar);
